import { Data, List, ModalUtils, NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { NotificationDuration } from "../../../../App/Models/NotificationDuration";
import { AppService, Types } from '../../../DomainTypes';
import IDTRate from '../../../Models/Catalogue/Pipeline/IDTRate';
import IDTRatePagedLookupCriteria from '../../../Models/Catalogue/Pipeline/Lookups/IDTRatePagedLookupCriteria';

@NeoModel
export default class IDTRateVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        protected pipelinesApiClient = AppService.get(Types.Domain.ApiClients.CataloguePipeline),
        public authorisationService = AppService.get(Types.Neo.Security.AuthorisationService),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications)) {

        super(taskRunner);
        this.autoDispose(this.criteria.onAnyPropertyChanged(() => this.pageManager.refreshData()));
    }

    public criteria = new IDTRatePagedLookupCriteria();

    public pageManager = new Data.PageManager(this.criteria, IDTRate, this.pipelinesApiClient.getIDTRateLookupsPaged, {
        pageSize: 15,
        initialTaskRunner: this.taskRunner,
        fetchInitial: true,
        allowSort: true,
        sortBy: 'rateDate',
        sortAscending: false,
    });

    public newIDTRate() {
        this.pageManager.data.addNew();
    }

    public saveIDTRates() {
        this.taskRunner.run(async () => {
            const response = await this.pipelinesApiClient.saveIDTRates(this.pageManager.data.toJSArray());
            this.pageManager.data.update(response.data);
            this.notifications.addSuccess("Save Successful", "IDT Rates were saved successfully.", NotificationDuration.Standard);
            this.pageManager.refreshData();
        });
    }
}